import React, { useState } from 'react'
import {
	TabPane,
	TabContent,
	Row,
	Col,
	Container,
	Nav,
	NavItem,
	NavLink,
	Badge
} from 'reactstrap'
import classnames from 'classnames';
import Subscription from './Subscription';
import UserProfile from './UserProfile';
import NotificationList from './NotificationList';
import NotificationSetting from './NotificationSetting';
import PaymentMethod from './payment/PaymentMethod';
import UpdatePassword from '../updatePassword';
import ReferFriend from './ReferFriend';
import PropertiesPageSettings from './PropertiesPageSettings';
import InvoicesSettings from './InvoicesSettings';

export default function Settings() {
	const Tabs = [
		{
			tabId: 'myProfile',
			name: 'My Profile'
		},
		{
			tabId: 'propertiesPageSettings',
			name: 'Properties Page Settings'
		},
		// Notifications tab hidden: the backend notification-settings mutation was
		// rearchitected (boolean flags -> preferences/frequencies/digest model) and
		// this legacy screen can no longer drive it. Restore once NotificationSetting.js
		// is ported to the new model.
		// {
		// 	tabId: 'notifications',
		// 	name: 'Notifications'
		// },
		{
			tabId: 'referFriend',
			name: 'Refer a Friend'
		}
	];

	if (localStorage.getItem('is_agent') !== 'true'){
		Tabs.push({
			tabId: 'subscriptions',
			name: 'Subscriptions'
		})
	}

	if (localStorage.getItem('is_broker') === 'true') {
		const insertIndex = Tabs.findIndex(tab => tab.tabId === 'propertiesPageSettings');
		if (insertIndex !== -1) {
			Tabs.splice(insertIndex + 1, 0, {
				tabId: 'invoicesSettings',
				name: 'Invoices Settings'
			});
		}
	}

	const [activeTab, setActiveTab] = useState('myProfile')
	return (
	<Row>
      <Col md='12' className='table-tabs mt-3'>
				{/* <Row> */}
					{/* <Col
						lg={{ size: 6, offset: 3 }}
            md={{ size: 8, offset: 2 }}
            className='text-left mt-3 mt-md-3'
					> */}
					<div className='d-flex justify-content-center'>
						<Nav tabs>
							{
								Tabs.map(tab => {
									return (
										<NavItem key={tab.tabId}>
											<NavLink
												className={classnames({
													active: activeTab === tab.tabId,
												})}
												onClick={() => {
													setActiveTab(tab.tabId);
												}}
											>
												{tab.name}
												{(tab.tabId === 'myProfile' && localStorage.getItem('is_profile_completed') === 'false') && (
													<Badge color="danger" className='ml-1' pill>1</Badge>
												)}
											</NavLink>
										</NavItem>
									)
								})
							}
						</Nav>
					</div>
					{/* </Col> */}
				{/* </Row> */}

				<TabContent activeTab={activeTab}>

					<TabPane tabId='myProfile'>
						<Row className='px-lg-5'>
							<Col lg='9' className='pr-2'>
								<UserProfile/>
							</Col>
							<Col lg='3'>
								<UpdatePassword showForm={true} />
							</Col>
						</Row>
					</TabPane>

					<TabPane tabId='subscriptions'>
						<Row className='px-lg-5'>
							<Col md='8'>
								<Subscription />
							</Col>
							<Col md='4' className='mt-5'>
								<PaymentMethod />
							</Col>
						</Row>
					</TabPane>

					<TabPane tabId='notifications'>
						<Row className='px-lg-5'>
							<Col md='12'>
								<NotificationSetting />
							</Col>
						</Row>
					</TabPane>

					<TabPane tabId='referFriend'>
						<Row className='px-lg-5'>
							<Col md='12'>
								<ReferFriend />
							</Col>
						</Row>
					</TabPane>

					<TabPane tabId='propertiesPageSettings'>
						<Container className='px-lg-5'>
							<div>
								<PropertiesPageSettings />
							</div>
						</Container>
					</TabPane>

					<TabPane tabId='invoicesSettings'>
						<Row className='px-lg-5'>
							<Col md='12'>
								<InvoicesSettings />
							</Col>
						</Row>
					</TabPane>

				</TabContent>
			</Col>
		</Row>
	)
}
